export default __webpack_public_path__ + "static/media/ug.4997f81f.png";